module.exports = __webpack_public_path__ + "static/media/76.0baff58e.png";